import React from 'react';

import styles from './editableImageStyles';

import CropperModal from 'buyside/components/presentation/CropperModal/cropperModal';

import FilePictureIcon from 'buyside/svgs/file_picture.svg';
import PlusIcon from 'buyside/svgs/plus.svg';

class EditableImage extends React.Component {
  constructor() {
    super();
    this.state = { modalOpen: false };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalOpen: true });
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  render() {
    const {
      isEditable,
      title,
      image,
      croppedImage,
      defaultImage,
      saveImage,
      isCircular,
      isBackground
    } = this.props;
    return (
      <div>
        {isEditable && (
          <CropperModal
            isOpen={this.state.modalOpen}
            closeModal={this.closeModal}
            title={title}
            aspectRatio={isBackground ? 3 : 1}
            image={image}
            defaultImage={defaultImage}
            saveImage={saveImage}
          />
        )}
        <figure
          onClick={isEditable ? this.openModal : null}
          className={`${styles.editableImageWrapper} ${isEditable &&
            styles.isEditable} ${isBackground && styles.isBackground} ${isCircular &&
            styles.circular}`}
        >
          {isBackground && (
            <span className={styles.editBackgroundImageLabel}>
              <FilePictureIcon />
              <strong>Edit Background Photo</strong>
            </span>
          )}
          {!isBackground && (
            <div className={styles.editImageLabel}>
              <PlusIcon />
              <span>{image === defaultImage ? 'Upload' : 'Edit'}</span>
              <span>{title}</span>
            </div>
          )}
          <img
            src={croppedImage}
            className={`${styles.editableImage} ${isBackground &&
              styles.isBackground} ${isCircular && styles.circular}`}
          />
        </figure>
      </div>
    );
  }
}

export default EditableImage;
